import { useEffect } from 'react';

/**
 * In dev, log LCP, CLS, FID (or INP) to console for performance checks.
 * Optional: call from App or admin layout.
 */
export function useWebVitals() {
  useEffect(() => {
    if (import.meta.env.PROD) return;
    import('web-vitals').then(({ getCLS, getLCP, getINP }) => {
      const log = (name: string) => (m: { value: number }) => console.log(`[WebVitals] ${name}`, m.value);
      getCLS(log('CLS'));
      getLCP(log('LCP'));
      getINP(log('INP'));
    }).catch(() => {});
  }, []);
}
